import { StrategyApi } from '@voladeum/client';
import { FORMAT_TYPE } from 'cyprus/enums';
import { formatValue } from 'cyprus/formats';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

import { EMPTY_ARRAY } from '../../../constants';
import { normalizeIndicators } from '../indicators/normalizers';
import { normalizeTriggers } from '../triggers/normalizers';

import { Strategy } from './types';

export const normalizeStrategies = (strategies: StrategyApi[]): Strategy[] =>
  strategies.map((strategy) => normalizeStrategy(strategy));

export const normalizeStrategy = (strategy: StrategyApi): Strategy => {
  const since_utc = moment.utc(strategy.since_milliseconds).toISOString();
  const to_utc = moment.utc(strategy.to_milliseconds).toISOString();
  return {
    ...strategy,
    backtest_lookback_days_formatted: formatValue(strategy.backtest_lookback_days, {
      format: FORMAT_TYPE.NUMBER,
    }),
    max_position_pct_formatted: formatValue(strategy.max_position_pct, {
      format: FORMAT_TYPE.PERCENT,
    }),
    max_daily_loss_pct_formatted: formatValue(strategy.max_daily_loss_pct, {
      format: FORMAT_TYPE.PERCENT,
    }),
    slippage_tolerance_pct_formatted: formatValue(strategy.slippage_tolerance_pct, {
      format: FORMAT_TYPE.PERCENT,
    }),
    max_drawdown_pct_formatted: formatValue(strategy.max_drawdown_pct, {
      format: FORMAT_TYPE.PERCENT,
    }),
    stop_loss_offset_pct_formatted: formatValue(strategy.stop_loss_offset_pct, {
      format: FORMAT_TYPE.PERCENT,
    }),
    take_profit_offset_pct_formatted: formatValue(strategy.take_profit_offset_pct, {
      format: FORMAT_TYPE.PERCENT,
    }),
    take_profit_trail_pct_formatted: formatValue(strategy.take_profit_trail_pct, {
      format: FORMAT_TYPE.PERCENT,
    }),
    strike_value_formatted: formatValue(strategy.strike_value, { format: FORMAT_TYPE.PERCENT }),
    expiry_value_formatted: formatValue(strategy.expiry_value, { format: FORMAT_TYPE.NUMBER }),
    since_utc,
    since_utc_formatted: formatValue(since_utc, { format: FORMAT_TYPE.DATE_SHORT }),
    to_utc,
    to_utc_formatted: formatValue(to_utc, { format: FORMAT_TYPE.DATE_SHORT }),
    activation_threshold_formatted: formatValue(strategy.activation_threshold, {
      format: FORMAT_TYPE.NUMBER,
    }),
    triggers: normalizeTriggers(strategy.triggers || EMPTY_ARRAY),
    indicators: normalizeIndicators(strategy.indicators || EMPTY_ARRAY),
    uuid: uuidv4(),
  };
};
